import React, { useMemo } from 'react'

import { LocationTooltip } from '@application/Interfaces/Features/Tradelanes/RouteElement/RouteElement.styled'
import { getMaxCharacter } from '@application/Utils/StringUtility'
import { useWidth } from '@icontainers/design-system/dist/utils'
import { Route } from '@src/Application/Types/ComponentTypes'

import {
    Arrow,
    FlagImage,
    Location,
    LocationName,
    RouteContent,
    RouteLinkArrow,
    RouteLinkDesktop,
    RouteLinkMobile,
    RouteLinkWrapper,
    TypeDesktop,
    TypeMobile,
    Wrapper,
} from './RouteElement.styled'

type RouteElementType = Route & {
    className?: string
}

export const RouteElement = (props: RouteElementType): JSX.Element => {
    const {
        type,
        originName,
        originIsoCode,
        originCountryFlag,
        destinationName,
        destinationIsoCode,
        destinationCountryFlag,
        link,
        linkLabel,
        className,
    } = props

    const { isMobile } = useWidth()

    const originLocation = useMemo(() => {
        return `${originName} (${originIsoCode})`
    }, [originName, originIsoCode])

    const destinationLocation = useMemo(() => {
        return `${destinationName} (${destinationIsoCode})`
    }, [destinationName, destinationIsoCode])

    return (
        <Wrapper className={className}>
            <RouteContent>
                <TypeDesktop color="gray" noBorder>
                    {type}
                </TypeDesktop>
                <Location>
                    <FlagImage image={originCountryFlag} width={20} height={20} />
                    {isMobile ? (
                        <LocationName>{originLocation}</LocationName>
                    ) : (
                        <LocationTooltip
                            tooltipEl={() => <LocationName>{getMaxCharacter(originLocation, 25)}</LocationName>}
                        >
                            {originLocation}
                        </LocationTooltip>
                    )}
                </Location>

                <Arrow colorCode="g500" direction={isMobile ? 'down' : 'right'} />
                <Location>
                    <FlagImage image={destinationCountryFlag} width={20} height={20} />

                    {isMobile ? (
                        <LocationName>{destinationLocation}</LocationName>
                    ) : (
                        <LocationTooltip
                            tooltipEl={() => <LocationName>{getMaxCharacter(destinationLocation, 25)}</LocationName>}
                        >
                            {destinationLocation}
                        </LocationTooltip>
                    )}
                </Location>
            </RouteContent>
            <RouteLinkWrapper>
                <TypeMobile color="gray" noBorder>
                    {type}
                </TypeMobile>
                <RouteLinkDesktop href={link}>
                    <RouteLinkArrow />
                </RouteLinkDesktop>
                <RouteLinkMobile to={link}>{linkLabel}</RouteLinkMobile>
            </RouteLinkWrapper>
        </Wrapper>
    )
}
